import React, { PureComponent } from "react";
import t from "@zendesk/client-i18n-tools";

import styles from "./index.css";

export default class ErrorScreen extends PureComponent {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          {t("knowledge-arrange.fatalApplicationLoadErrorTitle")}
        </div>
        <div className={styles.body}>
          {t("knowledge-arrange.fatalApplicationLoadErrorBody")}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorScreen/index.js